import { observer, useLocalObservable } from 'mobx-react';
import { useEffect } from 'react';

export default observer(({ componentName, children }) => {
  const localStore = useLocalObservable(() => ({
    ready: false,
  }));

  useEffect(() => {
    async function loadComponent() {
      const component = await import(
        `~/javascripts/alpine/components/${componentName}.js`
      );

      Alpine.data(componentName, component.default);

      localStore.ready = true;
    }

    loadComponent();
  }, []);

  if (!localStore.ready) {
    return null;
  }

  return <span {...{ 'x-data': `${componentName}()` }}>{children}</span>;
});
